// extracted by mini-css-extract-plugin
module.exports = {"time":"1s"};